import React from 'react';
import { Table, TableBody } from "@mui/material";
import Stack from "@mui/material/Stack";
import {
  StyledTableCell,
  StyledTableContentCell,
  StyledTableHeadContentCell,
  StyledTableHead,
  StyledTableHeadCell,
  StyledTableRow, StyledTableWrapper
} from "./styled";
import { LocaleCode, languages } from "shared/types/languages";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { Translations as TranslationsT } from "shared/types/languages";

export type TranslationField = {
  key: string;
  label: string;
  render: (props: {
    language: LocaleCode;
    value: string;
    onChange: (value: string) => void;
  }) => React.ReactNode;
}

type TranslationsProps = {
  fields: TranslationField[];
  translations?: TranslationsT;
  setTranslations: (translations: TranslationsT) => void;
};

const Translations: React.FC<TranslationsProps> = ({
  fields,
  translations,
  setTranslations,
}) => {
  const handleChange = (field: string, language: LocaleCode, value: string) => {
    setTranslations({
      ...translations,
      [language]: {
        ...(translations?.[language] || {}),
        [field]: value,
      },
    });
  };

  return (
    <Stack spacing="1rem">
      <ContentSection>
        <StyledTableWrapper>
          <Table>
            <StyledTableHead>
              <StyledTableRow>
                <StyledTableHeadCell>Content Type</StyledTableHeadCell>
                {languages.map((language) => (
                  <StyledTableHeadContentCell key={language.id}>
                    {language.name}
                  </StyledTableHeadContentCell>
                ))}
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              {fields.map((field) => (
                <StyledTableRow key={field.key}>
                  <StyledTableCell style={{
                    padding: "12px",
                    paddingTop: "16px",
                  }}>{field.label}</StyledTableCell>
                  {languages.map((language) => (
                    <StyledTableContentCell key={language.id}>
                      {field.render({
                        language: language.id,
                        value: translations?.[language.id]?.[field.key] || '',
                        onChange: (value) => handleChange(field.key, language.id, value),
                      })}
                    </StyledTableContentCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </StyledTableWrapper>
      </ContentSection>
    </Stack>
  );
};

export default Translations;